module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-preview"
  }, [(_vm.resolvedType === 'image') ? _c('div', {
    staticClass: "file-preview-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.httpsUrl
    }
  })]) : (_vm.resolvedType === 'video') ? _c('video', {
    staticClass: "file-preview-media",
    attrs: {
      "src": _vm.httpsUrl,
      "controls": ""
    }
  }) : (_vm.resolvedType === 'audio') ? _c('audio', {
    staticClass: "file-preview-audio",
    attrs: {
      "src": _vm.httpsUrl,
      "controls": ""
    }
  }) : (_vm.resolvedType === 'office') ? _c('div', {
    staticClass: "handbook-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.officeViewerUrl,
      "width": "100%",
      "height": "600",
      "frameborder": "0"
    }
  })]) : (_vm.resolvedType === 'pdf') ? _c('div', {
    staticClass: "handbook-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.httpsUrl,
      "width": "100%",
      "height": "600",
      "frameborder": "0"
    }
  })]) : (_vm.resolvedType === 'csv') ? _c('div', {
    staticClass: "csv-preview"
  }, [(_vm.tableLoading) ? _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("Loading preview...")])]) : (_vm.tableError) ? _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v(_vm._s(_vm.tableError))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1) : (_vm.csvHeaders.length) ? _c('div', {
    staticClass: "csv-table-wrap"
  }, [_c('table', {
    staticClass: "csv-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.csvHeaders), function(h, i) {
    return _c('th', {
      key: 'h-' + i
    }, [_vm._v(_vm._s(h))])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.csvRows), function(row, ri) {
    return _c('tr', {
      key: 'r-' + ri
    }, _vm._l((row), function(cell, ci) {
      return _c('td', {
        key: 'c-' + ri + '-' + ci
      }, [_vm._v(_vm._s(cell))])
    }), 0)
  }), 0)])]) : _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("Preview is empty.")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1)]) : _c('div', {
    staticClass: "file-preview-unknown"
  }, [_c('p', [_vm._v("This file type cannot be previewed in the browser.")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cb472ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FilePreview.vue
// module id = 1751
// module chunks = 8